<template>
  <div class="handleAgreement">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      :before-close="handleClose"
    >
      <div class="form_box">
        <el-form
          ref="formInline"
          :model="formInline"
          :rules="rules"
          label-width="120px"
        >
          <el-form-item label="协议模板名称" prop="contractName">
            <el-input
              v-model.trim="formInline.contractName"
              placeholder="请输入协议模板名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="协议模板地址" prop="templateUrl">
            <el-input
              readonly
              v-model.trim="formInline.templateUrl"
              placeholder="请输入协议模板地址"
            >
              <template slot="append">
                <Uploading v-model="formInline.templateUrl" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="范本地址" prop="modelUrl">
            <el-input
              readonly
              v-model.trim="formInline.modelUrl"
              placeholder="请输入范本地址"
            >
              <template slot="append">
                <Uploading v-model="formInline.modelUrl" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input
              type="textarea"
              maxlength="300"
              show-word-limit
              v-model.trim="formInline.remarks"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="handleAffirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Uploading from "@/views/class/modelAgreement/components/uploading.vue";
import {
  addContractTemplate,
  updateContractTemplate,
} from "@/api/class/modelAgreement.js";
export default {
  components: {
    Uploading,
  },
  data() {
    return {
      dialogTitle: "",
      dialogVisible: false,
      formInline: {
        contractName: "",
        templateUrl: "",
        modelUrl: "",
        remarks: "",
      },
      rules: {
        contractName: [
          { required: true, message: "请输入协议模板名称", trigger: "blur" },
        ],
        templateUrl: [
          { required: true, message: "请输入协议模板地址", trigger: "blur" },
        ],
      },
      status: "",
    };
  },
  methods: {
    // 初始化
    init(status, payload) {
      this.status = status;
      this.initData(payload);
      this.dialogTitle = status === "add" ? "添加协议模板" : "编辑协议模板";
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formInline.clearValidate();
      });
    },
    // 初始化数据
    initData(payload) {
      if (this.status === "add") {
        this.formInline = this.$options.data().formInline;
      } else if (this.status === "alter") {
        this.formInline = {
          id: payload.id,
          contractName: payload.contractName,
          templateUrl: payload.templateUrl,
          modelUrl: payload.modelUrl,
          remarks: payload.remarks,
        };
      }
    },
    // 取消
    handleClose() {
      this.dialogVisible = false;
    },
    // 确认
    handleAffirm() {
      this.$refs["formInline"].validate((valid) => {
        if (valid) {
          if (this.status === "add") {
            addContractTemplate({ ...this.formInline }).then((res) => {
              if (res.code === 0) {
                this.$parent.refresh();
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.dialogVisible = false;
              }
            });
          } else if (this.status === "alter") {
            updateContractTemplate({ ...this.formInline }).then((res) => {
              if (res.code === 0) {
                this.$parent.refresh();
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.dialogVisible = false;
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.handleAgreement {
}
</style>